import controller from './query-editor.controller';
import template from './query-editor.html';
import './query-editor.scss';

export default {
	controller,
	template,
	bindings: {
		ctrl: '<',
		tab: '=ngModel',
	},
	require:  {
		ngModelCtrl: '?ngModel',
	},
};
